import WorkflowRunFilterView from '@UI/Pages/WorkflowRuns/Filters/WorkflowRunFilterView';
import { createSignal } from '@verclam/pulsar';

// Neither scope field is resolved yet at this point, so `belongsTo` rejects this initial value as
// soon as a real facility and user are known: the derivation hook covers the first render.
const workflowRunFiltersSignal = createSignal<WorkflowRunFilterView>(
	WorkflowRunFilterView.createDefault(null, null),
);

export const setWorkflowRunFilters = (filters: WorkflowRunFilterView): void => {
	workflowRunFiltersSignal.value = filters;
};

export default workflowRunFiltersSignal;
